<template>
  <ul class="statusList">
    <li
      :class="{ secondAshComWrap: true, activeLi: activeLi == i }"
      v-for="(v, i) in list"
      :key="i"
      @click="changeActive(v, i)"
    >
      <div class="comTitle">
        <h4>{{ v.title }}</h4>
        <el-radio-group
          v-if="v.active"
          v-model="v.active"
          size="mini"
          @change="changeType(v, i)"
        >
          <el-radio label="DAY">今日</el-radio>
          <el-radio label="MONTH">本月</el-radio>
          <el-radio label="YEAR">今年</el-radio>
        </el-radio-group>
      </div>
      <div class="comContentBox liContent">
        <div class="itemBox" v-for="(item, index) in v.data" :key="index">
          <p>
            {{ item.value }}<span v-if="item.unit">{{ item.unit }}</span>
          </p>
          <p>
            {{ item.name }}
          </p>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
import api from "@/api";
import { matchingDynamicalState } from "@/assets/js/utils";
export default {
  props: {
    activeTree: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      activeLi: 0,
      defaultList: [
        { title: "实时状态", data: [] },
        { title: "能耗", data: [], active: "DAY" },
        { title: "运转分析", data: [], active: "DAY" },
        { title: "环境监测", data: [] },
        { title: "报警分析", data: [], active: "DAY" },
        { title: "运维分析", data: [], active: "DAY" },
      ],
      list: [],
    };
  },
  watch: {
    activeTree: {
      handler(newvalue, oldvalue) {
        this.getCardList();
      },
      deep: true,
    },
  },
  methods: {
    changeType(item, index) {
      if (item.title == "能耗") {
        this.getEcData(index);
      } else if (item.title == "运转分析") {
        this.getOperationsAnalysis(index);
      } else if (item.title == "报警分析") {
        this.getAlarmAnalysis(index);
      }
    },
    changeActive(item, index) {
      this.activeLi = index;
      this.$emit("getClickData", item.title);
    },
    getCardList() {
      if (
        this.activeTree.type == "项目" ||
        this.activeTree.type == "区域资产"
      ) {
        this.list = this.defaultList.filter((v) => {
          return v.title != "环境监测";
        });
      } else {
        this.list = JSON.parse(JSON.stringify(this.defaultList));
      }
      this.changeActive(this.list[0], 0);

      this.getRealTime();
      this.getEcData(
        this.list.findIndex((v) => {
          return v.title == "能耗";
        })
      );
      this.getOperationsAnalysis(
        this.list.findIndex((v) => {
          return v.title == "运转分析";
        })
      );
      this.getAlarmAnalysis(
        this.list.findIndex((v) => {
          return v.title == "报警分析";
        })
      );
      this.getDevOpsAnalysis(
        this.list.findIndex((v) => {
          return v.title == "运维分析";
        })
      );

      if (
        this.activeTree.type != "项目" &&
        this.activeTree.type != "区域资产"
      ) {
        this.getStateEnvironment();
      }
    },
    // 实时状态
    async getRealTime() {
      let index = this.list.findIndex((v) => {
        return v.title == "实时状态";
      });
      this.list[index].data = [];
      let res = await api.DynamicalStateRealTime({
        deviceTypes: "直梯,扶梯,加速带",
        entityId: this.activeTree.id,
      });
      if (res && res.data.code == 200) {
        this.list[index].data = Array.from(res.data.data).map((v) => ({
          name: v.name,
          unit: v.unit,
          value:
            v.name == "状态"
              ? v.value == -1
                ? "未知"
                : matchingDynamicalState(v.value)
              : v.value,
        }));
      }
    },
    // 能耗
    async getEcData(index) {
      let res = await api.DynamicalStateEC({
        type: this.list[index].active,
        entityId: this.activeTree.id,
      });
      if (res && res.data.code == 200) {
        this.list[index].data = res.data.data;
      }
    },
    // 运转分析
    async getOperationsAnalysis(index) {
      let res = await api.DynamicalStateOperationsAnalysis({
        type: this.list[index].active,
        entityId: this.activeTree.id,
      });
      if (res && res.data.code == 200) {
        this.list[index].data = res.data.data;
      }
    },
    // 环境监测
    async getStateEnvironment() {
      let index = this.list.findIndex((v) => {
        return v.title == "环境监测";
      });
      this.list[index].data = [];
      let res = await api.DynamicalStateEnvironment({
        entityId: this.activeTree.id,
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        modular: "环境监测",
      });
      if (res && res.data.code == 200) {
        this.list[index].data = res.data.data[0]?.values;
      }
    },
    // 报警分析
    async getAlarmAnalysis(index) {
      let res = await api.DynamicalStateAlarm({
        type: this.list[index].active,
        entityId: this.activeTree.id,
      });
      if (res && res.data.code == 200) {
        this.list[index].data = res.data.data;
      }
    },
    //运维分析
    async getDevOpsAnalysis(index) {
      let res = await api.DynamicalStateDevOpsAnalysis({
        type: this.list[index].active,
        entityId: this.activeTree.id,
      });
      if (res && res.data.code == 200) {
        this.list[index].data = res.data.data;
      }
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.statusList {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 12px;
  ::v-deep .el-radio {
    margin-right: 5px;
    .el-radio__input {
      display: none;
    }
  }
  li {
    width: 32%;
    height: 110px;
    margin: 0 12px 12px 0;
    border-radius: 12px;
    border: 1.5px solid transparent;
    cursor: pointer;
    .liContent {
      width: 90%;
      margin: 0 auto;
      @include setFlexBetween;
      .itemBox {
        text-align: center;
        p:nth-child(1) {
          color: $themeColor;
          font-weight: bold;
          margin-bottom: 5px;
        }
      }
    }
  }
  li:nth-child(3),
  :nth-child(6) {
    margin-right: 0;
  }

  li:hover {
    border-color: #7ee0e0;
  }
  .activeLi {
    border-color: $themeColor !important;
  }
}
</style>
